import { mapDTO } from '@twistezo/ts-dto-mapper'

import { WorkspaceBidderSlice } from './../types'
import { WorkspaceBidderSliceDTO } from './types'

type From = WorkspaceBidderSliceDTO
type To = WorkspaceBidderSlice

export const fromDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform((dto: From): To => {
    const { bidderCode, id } = dto

    return {
      bidderCode,
      id,
    }
  })
